import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { QrCode, Upload, Save, Loader2, Phone, MessageCircle } from 'lucide-react';

const AdminSettings = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [currentQr, setCurrentQr] = useState(null);
  const [whatsappNumber, setWhatsappNumber] = useState(''); // حقل رقم الواتساب
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState(''); // لحالات النجاح البسيطة

  const BASE_URL = 'https://my-pharmacy-api.onrender.com';

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/settings/qr`);
      if (res.data) {
        // التعديل: استلام رابط Cloudinary المباشر
        if (res.data.qr_image_url) setCurrentQr(res.data.qr_image_url);
        if (res.data.whatsapp_number) setWhatsappNumber(res.data.whatsapp_number);
      }
    } catch (err) {
      console.error("خطأ في جلب الإعدادات:", err);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleUpdateAll = async () => {
    setLoading(true);
    try {
      // 1. تحديث رقم الواتساب أولاً
      if (whatsappNumber) {
        await axios.post(`${BASE_URL}/api/settings/whatsapp`, { 
          whatsapp_number: whatsappNumber 
        });
      }

      // 2. تحديث صورة الـ QR إذا تم اختيار ملف جديد
      if (file) {
        const data = new FormData();
        data.append('qr', file);
        const res = await axios.post(`${BASE_URL}/api/settings/qr`, data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        // التعديل: السيرفر سيعيد رابط Cloudinary الجديد (qrUrl)
        if (res.data.qrUrl) setCurrentQr(res.data.qrUrl);
      }

      alert("✅ تم حفظ الإعدادات بنجاح");
      setPreview(null);
      setFile(null);
    } catch (err) {
      console.error("خطأ في الحفظ:", err);
      alert("❌ فشل الحفظ: تأكد من اتصال السيرفر");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="max-w-md mx-auto p-8 bg-white dark:bg-[#161B22] rounded-[40px] shadow-2xl border border-gray-50 dark:border-gray-800 mt-10 mb-10">
      <div className="text-center mb-8">
        <div className="bg-indigo-600 w-16 h-16 rounded-3xl flex items-center justify-center mx-auto mb-4 text-white shadow-lg">
          <QrCode size={32} />
        </div>
        <h2 className="text-2xl font-black text-gray-800 dark:text-white">إعدادات الصيدلية</h2>
        <p className="text-gray-400 text-sm font-bold">تحديث بيانات التواصل والدفع</p>
      </div>

      <div className="space-y-6">
        
        {/* --- حقل رقم الواتساب الجديد --- */}
        <div className="space-y-2">
          <label className="text-xs font-black text-gray-500 mr-2 uppercase tracking-wider flex items-center gap-1">
            <MessageCircle size={14} /> رقم واتساب التواصل
          </label>
          <div className="relative group">
            <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none text-green-500">
              <Phone size={18} />
            </div>
            <input 
              type="text" 
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              placeholder="مثال: 9639xxxxxxxx"
              className="w-full pr-12 pl-4 py-4 bg-gray-50 dark:bg-gray-900 border-2 border-transparent focus:border-green-500 dark:text-white rounded-2xl outline-none transition-all font-bold text-sm"
            />
          </div>
          <p className="text-[10px] text-gray-400 mr-2">هذا الرقم سيظهر للزبائن عند اختيار "الاستلام من الصيدلية".</p>
        </div>

        <hr className="border-gray-100 dark:border-gray-800" />

        {/* --- قسم QR كود --- */}
        <div className="space-y-2">
          <label className="text-xs font-black text-gray-500 mr-2 uppercase tracking-wider flex items-center gap-1">
            <QrCode size={14} /> رمز QR شام كاش
          </label>
          <div className="relative aspect-square bg-gray-50 dark:bg-gray-900 rounded-[35px] border-4 border-dashed border-gray-200 dark:border-gray-700 flex items-center justify-center overflow-hidden">
            {preview ? (
              <img src={preview} className="w-full h-full object-contain p-4" alt="Preview" />
            ) : currentQr ? (
              /* التعديل هنا: نستخدم currentQr مباشرة لأنه رابط كامل من Cloudinary */
              <img src={`${currentQr}`} className="w-full h-full object-contain p-4" alt="Current QR" />
            ) : (
              <div className="text-center text-gray-300">
                <Upload size={48} className="mx-auto mb-2 opacity-20" />
                <p className="text-xs font-black uppercase">لا يوجد كود حالي</p>
              </div>
            )}
          </div>
        </div>

        <div className="relative">
          <input 
            type="file" 
            id="qr-upload"
            onChange={handleFileChange} 
            className="hidden" 
            accept="image/*"
          />
          <label 
            htmlFor="qr-upload"
            className="flex items-center justify-center w-full py-4 px-4 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 rounded-2xl border-2 border-indigo-100 dark:border-indigo-800 border-dashed cursor-pointer hover:bg-indigo-100 transition-all font-bold text-sm"
          >
            <Upload size={18} className="ml-2" />
            {file ? file.name : "تغيير صورة الـ QR"}
          </label>
        </div>

        {/* زر الحفظ النهائي */}
        <button 
          onClick={handleUpdateAll}
          disabled={loading}
          className={`w-full py-4 rounded-[22px] font-black flex items-center justify-center gap-2 transition-all shadow-xl active:scale-95 ${
            loading ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-900 text-white hover:bg-indigo-600'
          }`}
        >
          {loading ? <Loader2 className="animate-spin" size={20} /> : <Save size={20} />}
          {loading ? "جاري الحفظ..." : "حفظ كافة الإعدادات"}
        </button>
      </div>
    </div>
  );
};

export default AdminSettings;